import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { NewText } from "ui"

type DocumentHeaderProps = {
  title: string
  totalFiles: number
  messages: any
  onDownloadAll: () => void
}

const StyledDiv = styled.div`
  padding-top: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
  }
`

const StyledWrapper = styled.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const StyledDownloadAllButton = styled(Button)`
  height: 48px;
  border-radius: 200px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #2768a3;
  color: white;
  text-decoration: none;
  :hover {
    text-decoration: none;
    background-color: #2768a3;
    color: white;
  }
`

const DocumentHeader = ({ title, totalFiles, messages, onDownloadAll }: DocumentHeaderProps) => {
  return (
    <StyledDiv>
      <NewText
        component={"h2"}
        desktopFontSize={48}
        desktopFontWeight={600}
        mobileFontSize={40}
        desktopLineHeight={"100%"}
        mobileLineHeight={"46px"}
        color="#2768A3"
      >
        {title}
      </NewText>
      <StyledWrapper>
        <NewText component={"p"} desktopFontSize={18} color="black">
          {messages.total} <span style={{ fontWeight: 700 }}>{totalFiles} </span>
          {messages.documents}{" "}
        </NewText>
        <StyledDownloadAllButton onClick={onDownloadAll}>
          {messages.downloadAll}
        </StyledDownloadAllButton>
      </StyledWrapper>
    </StyledDiv>
  )
}

export default DocumentHeader
